<main class="main-container">
    <div class="big-container">
        <h1 class="logo">STESAJ</h1>
        <div class="title-container">
            <h2 class="main-title">Soporte tecnológico educativo de simulación en administración de justicia</h2>
            <div class="gold-box"></div>
            <div class="white-box"></div>
        </div>
        <footer class="footer">
            <ul>
                <li class="link">Este es un prototipo desarrollado por el laboratorio LiiD</li>
                <li class="link link-end">UTPL {{ currentYear }}</li>
            </ul>
        </footer>
    </div>
    <div class="small-container">
        <div class="form-container">
            <h2 class="title">Iniciar Sesión</h2>

            <div class="btn-sesion">
                <p>Ya tienes una cuenta UTPL, inicia sesión aquí</p>
                <button mat-button (click)="loginUtpl()" class="btn-submit">Iniciar Sesión UTPL</button>
            </div>

            <br>
            <div class="line-container">
                <hr class="line">
                <p>O</p>
                <hr class="line">
            </div>

            <p class="text-login">Inicia sesión o regístrate</p>
            <div class="login">
                <button mat-button (click)="login()" class="btn-login">Iniciar Sesión</button>
                <button mat-button (click)="register()" class="btn-login">Regístrarse</button>
            </div>



        </div>
    </div>
</main>
